
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { type MaxCollectInteractionsCard } from '@xt/client/types/record-card'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class MaxCollectInteractionsCards extends Vue {
  @Prop() data: MaxCollectInteractionsCard
  @Prop({ default: true }) showRefreshBtn: boolean

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
